
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/contributors/[[...username]]",
      function () {
        return require("private-next-pages/network/contributors/[[...username]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network/contributors/[[...username]]"])
      });
    }
  